// extracted by mini-css-extract-plugin
module.exports = {"tabs":"styles_tabs__3HbKe","button":"styles_button__2F_ZZ","selectedButton":"styles_selectedButton__2aud4"};